/*eslint-disable*/
import { useState, useEffect } from "react";
import {
    Button,
    Card,
    CardHeader,
    Spinner,
    Input,
} from 'reactstrap';


import './loader.scss';

// source code- https://codepen.io/hijiangtao/pen/VBEvMW?editors=1100

const BasicLoader = ({
    height,
    width
}) => {
    const activeSpace = window.location.host.split('.')[0];


    return (
        <div className={`main-item `} style={{ width }}>
            <div className={`animated-background `} style={{ height }}>
                <div className="background-masker"></div>
            </div>
        </div>
    )
};

export default BasicLoader;
